<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

     <div color="primary" dark >
        <h2>Transaction Details</h2>
    </div>

    <v-card-title>
      <v-autocomplete            
      label="Voucher Type"
      item-text="name"
      item-value="name"
      v-model="searchField.voucher_type"            
      :items="finVoucherList" 
      clearable
      single-line hide-details         
      ></v-autocomplete>

      <v-spacer></v-spacer>

      <DatePicker
          :key="formSchema.id"
          :inputData="{index:1,fieldName:'from_date', fieldValue:searchField.from_date, label:'From Date'}"
          @setValue="setDateValue"
      ></DatePicker>
      <v-spacer></v-spacer>
      <DatePicker
          :key="formSchema.id"
          :inputData="{index:1,fieldName:'to_date', fieldValue:searchField.to_date, label:'To Date'}"
          @setValue="setDateValue"
      ></DatePicker>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-btn color="success" single-line hide-details @click="searhByVal">
        <v-icon>search</v-icon>
      </v-btn>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.voucher_number }}</td>
        <td class="text-xs-left">{{ props.item.voucher_type }}</td>
        <td class="text-xs-left">{{ props.item.currency_code }}</td>
        <td class="text-xs-left">{{ props.item.usd_rate }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.voucher_date) }}</td>
        <td class="text-xs-left">{{ (props.item.is_post == 1) ? 'Yes' : 'No' }}</td>

        <td class="justify-center text-xs-center layout px-0">
          <v-btn icon class="mx-0" @click="viewVoucher(props.item.id)">
            <v-icon color="teal">view_module</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";
import ServerPath from '../../../server-path/server-path';
import Axios from "axios";

export default {
  components: { DatePicker },

  data: () => ({
    valid: true,
    sm_id:'',

    searchField:{
      voucher_type:'',
      from_date:'',
      to_date:''
    },
    finVoucherList: [
      {name:'Fund Released'},
      {name:'Withdrawal'},
      {name:'Refund'},
      {name:'Fund Receive'},
      {name:'Disbursment'},
      {name:'Re-Payment'},
      {name:'Early-Settlement'},
      {name:'Partial-Payment'}
    ],

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Voucher No",
        align: "left",
        sortable: true,
        value: "voucher_number"
      },
      { text: "Type", align: "left", sortable: true, value: "voucher_type" },
      {
        text: "Currency",
        align: "left",
        sortable: true,
        value: "currency_code"
      },
      { text: "USD Rate", align: "left", sortable: true, value: "usd_rate" },
      { text: "Date", align: "left", sortable: true, value: "voucher_date" },
      { text: "Post Status", align: "left", sortable: true, value: "is_post" },

      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: 0,
      type_name: "",
      short_name: ""
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },
  mounted() {
    let sm_id = sessionStorage.getItem('sm_id');
  },

  created(){
    
    
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    viewVoucher(id){
      let sm_id = sessionStorage.getItem('sm_id');
      let onlyParam = {id:id,sm_id:sm_id,report_type:1,conName:2,funcName:'voucher_view'}
      let parameters = new URLSearchParams({ ...onlyParam}).toString();
      sessionStorage.setItem('report', JSON.stringify(onlyParam))
      let route = ServerPath.serverPath+'/pdf?'+parameters;
      window.open(route, '_blank');
    },

    searhByVal()
    {
      this.getDataFromApi().then(data => {          
        this.desserts = data.items;
        this.totalDesserts = data.total;
      });
    },

    setDateValue(data) {
      let index = data.index;
      this.searchField[data.fieldName] = this.changeFormateYMD(data.value);
    },

    getDataFromApiXXX() {
      //let sm_id = sessionStorage.getItem('sm_id');
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search),
          (query_Data.voucher_type = this.searchField.voucher_type),
          (query_Data.from_date = this.searchField.from_date),
          (query_Data.to_date = this.searchField.to_date);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "voucher_all_details")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search),
          (query_Data.voucher_type = this.searchField.voucher_type),
          (query_Data.from_date = this.searchField.from_date),
          (query_Data.to_date = this.searchField.to_date);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService.getServerSideData(query_Data, "voucher_all_details").then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      //sessionStorage.setItem("voucher_info", item.id);
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$store.commit("SET_VOUCHER_ENTRY_DATA", item);
      this.$router.push("/procurement/voucher_form");
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "voucher_master").then(res => {
        this.desserts.splice(row_index, 1);
        this.close(res);
        this.confirmModel = false;
      });
    },

    // confirmDelete(row_index, id) {
    //   commonService.deleteRow(id,"voucher_master").then(res => {
    //     if (res.status == 1) {
    //       this.desserts.splice(row_index, 1);
    //       this.getDataFromApi();
    //     } else {
    //       this.SnackbarVal.color = "error";
    //     }
    //     this.SnackbarVal.message = res.message;
    //     this.SnackbarVal.snackbar = true;

    //     this.confirmModel = false;
    //     this.dialog2 = false;
    //   });
    // },

    close(res) {
      let $this = this;
      if (res.status == 1) {
        if (res.action == "add") {
          $this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          $this.$set($this.desserts, $this.row_index, { ...res.data });
          $this.row_index = "";
        }
        this.SnackbarVal.color = "success";
      }
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/voucher/voucher_all_list.vue